import axios from "./base"; // var str= 'companyId=175739; SESSION=491faf5b-96b2-4411-9481-e91f83988fd8'
// var arr = str.split(';');
// arr.forEach((item) => {
//   document.cookie = item;
// });
// localStorage.setItem("token", "0541816a-641f-4494-9a65-df131280d50f")

export default {
  get(url, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        params
      }).then(res => {
        resolve(res.data);
      }, err => {
        reject(err);
      }).catch(error => {
        reject(error);
      });
    });
  },

  getStream(url, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        params
      }).then(res => {
        resolve(res);
      }, err => {
        reject(err);
      }).catch(error => {
        reject(error);
      });
    });
  },

  post(url, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: url,
        // data: qs.stringify(data)
        data
      }).then(res => {
        resolve(res.data);
      }, err => {
        reject(err);
      }).catch(error => {
        reject(error);
      });
    });
  },

  put(url, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: url,
        data
      }).then(res => {
        resolve(res.data);
      }, err => {
        reject(err);
      }).catch(error => {
        reject(error);
      });
    });
  },

  del(url, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: url,
        params
      }).then(res => {
        resolve(res.data);
      }, err => {
        reject(err);
      }).catch(error => {
        reject(error);
      });
    });
  },

  patch(url, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'patch',
        url: url,
        // data: qs.stringify(data)
        data
      }).then(res => {
        resolve(res.data);
      }, err => {
        reject(err);
      }).catch(error => {
        reject(error);
      });
    });
  }

};